import React, { Fragment } from 'react';
import {translate} from 'react-i18next';
import {Button, Icon} from 'antd';
import {COLOR_FONT_DISABLED, MODAL_WIDTH_XL} from '../../../../../styles/constants';
import FileMappingWizardComponentValueDefinitionForm from './component-value';
import EnhancedModal from '../../../../../components/enhanced-modal';
import { valueIsValid } from '../utils';

const IconFontCNIcon = Icon.createFromIconfontCN({
  scriptUrl: './static/vendor/iconfont_cn/iconfont.js',
});

const FileMappingWizardComponentList = ({
                                          t,
                                          appLanguage,
                                          components,
                                          disabled,
                                          hasIcon,
                                          selected,
                                          onSelect,
                                          showValueDefinitionButton,
                                          componentValueDefinitionFormVisible,
                                          onComponentCsvEdit,
                                          onComponentCalculatedDelete,
                                          onComponentCalculatedEdit,
                                          onComponentValueDefinitionFormShow,
                                          onComponentValueDefinitionFormHide,
                                          onComponentValueDefinitionSave,
                                          onComponentValueDefinitionTypeSet,
                                          componentValueDefinition,
                                          onComponentValueDefinitionValueSet,
                                          componentCodelistCodesItemsPage,
                                          componentCodelistCodesItemsCount,
                                          fetchCodelistCodesItemsPage,
                                          tempTableName
                                        }) => {

 const onSaveValueDefinition = () => {
  onComponentValueDefinitionSave();
  onComponentValueDefinitionFormHide();
 }                                          
  return (
    
    <Fragment>

      <div
        style={{
          overflow: "auto",
          height: "100%",
          border: "1px solid #e8e8e8",
          paddingLeft: 4,
          paddingRight: 4
        }}
      >
        {
          (components || []).map((component, index) =>
            <div
              key={index}
              onClick={() => {
                if(!disabled.includes(component.name)) {
                  if (component.headers) {
                    if(component.selected) {
                      return onSelect(component);
                    }
                  }
                  else {
                    return onSelect(component);
                  }
                }}}
              title={t("commons.actions.select.title") + ' ' + component.name}
              className={disabled.includes(component.name)
                ? "ant-select-disabled"
                : ""
              }
              style={{
                paddingTop: 2,
                paddingBottom: 2,
                paddingLeft: 8,
                paddingRight: 4,
                background: component.name === selected
                  ? "#ffafa3"
                  : (index % 2)
                    ? "#f5f5f5"
                    : "#ffffff",
                borderTop: "1px solid #e8e8e8",
                cursor: 'pointer',
                minWidth: 120
              }}
            >
              {
                hasIcon
                  ? (
                    <Icon
                      type={component.icon}
                      style={{
                        width: 16,
                        marginRight: 8,
                        verticalAlign: "middle",
                        display: "inline-block",
                        color: disabled.filter(el => el === component.name).length > 0 || (component.headers && !component.selected) ? COLOR_FONT_DISABLED : undefined,
                      }}
                    />
                  )
                  : null
              }
              <div
                style={{
                  width: hasIcon
                    ? (showValueDefinitionButton && component.name === selected && component.canAssociateValue) ? "calc(100% - 80px)" : "calc(100% - 56px)"
                    : !component.calculated ? (showValueDefinitionButton && component.name === selected && tempTableName !== null) ? "calc(100% - 56px)" : "calc(100% - 32px)"
                    : (showValueDefinitionButton && component.name === selected) ? "calc(100% - 80px)" : "calc(100% - 32px)",
                  verticalAlign: "middle",
                  display: "inline-block",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  color: disabled.filter(el => el === component.name).length > 0 || (component.headers && !component.selected) ? COLOR_FONT_DISABLED : undefined,
                  fontWeight: disabled.filter(el => el === component.name).length > 0 || (component.headers && !component.selected) ? undefined : "bold",
                }}
              >
                {
                  component.IsMandatory
                    ? <IconFontCNIcon type="m" style={{marginRight: 4}} title="Mandatory"/>
                    : null
                }
                {component.name}
              </div>
              {showValueDefinitionButton && component.name === selected && component.canAssociateValue && component.calculated === false
              ? <Icon
                  title={t("commons.actions.select.title") + ' ' + component.name}
                  style={{
                    width: 16,
                    marginLeft: 8,
                    verticalAlign: "middle",
                    display: "inline-block"
                  }}
                  onClick={
                    onComponentValueDefinitionFormShow
                      ? (
                        e => {
                          e.stopPropagation();
                          onComponentValueDefinitionFormShow(component);
                        }
                      )
                      : null
                  }
                  type="plus"
                />
              : null}
              {component.name === selected && component.calculated === true 
                ? <Icon
                    title={t("commons.actions.delete.title") + ' ' + component.name}
                    style={{
                      width: 16,
                      marginLeft: 8,
                      verticalAlign: "middle",
                      display: "inline-block"
                    }}
                    onClick={
                      onComponentCalculatedDelete
                        ? (
                          e => {
                            e.stopPropagation();
                            onComponentCalculatedDelete(component);
                          }
                        )
                        : null
                    }
                    type="delete"
                  />
                : null
              }
              {component.name === selected && component.calculated === false && component.headers === true && tempTableName !== null
                ? <Icon
                    title={t("commons.actions.edit.title") + ' ' + component.name}
                    style={{
                      width: 16,
                      marginLeft: 8,
                      verticalAlign: "middle",
                      display: "inline-block"
                    }}
                    onClick={
                      onComponentCsvEdit
                        ? (
                          e => {
                            e.stopPropagation();
                            onComponentCsvEdit(component);
                          }
                        )
                        : null
                    }
                    type="edit"
                  />
                : null
              }
              {component.name === selected && component.calculated === true 
                ? <Icon
                    title={t("commons.actions.edit.title") + ' ' + component.name}
                    style={{
                      width: 16,
                      marginLeft: 8,
                      verticalAlign: "middle",
                      display: "inline-block"
                    }}
                    onClick={
                      onComponentCalculatedEdit
                        ? (
                          e => {
                            e.stopPropagation();
                            onComponentCalculatedEdit(component);
                          }
                        )
                        : null
                    }
                    type="edit"
                  />
                : null
              }
              <Icon
                title={component.detailTitle}
                style={{
                  width: 16,
                  marginLeft: 8,
                  verticalAlign: "middle",
                  display: "inline-block",
                  cursor: component.onDetail !== null ? 'pointer' : 'not-allowed',
                  color: component.onDetail === null || (component.headers && !component.selected) ? COLOR_FONT_DISABLED : null
                }}
                onClick={
                  component.onDetail !== null
                    ? (
                      e => {
                        e.stopPropagation();
                        component.onDetail(component);
                      }
                    )
                    : null
                }
                type="file-search"
              />              
            </div>
          )
        }
      </div>

      <EnhancedModal
        visible={componentValueDefinitionFormVisible}
        width={MODAL_WIDTH_XL}
        title={t('scenes.dataManager.fileMapping.wizard.cards.cubeComponents.cubeComponentList.valueDefinitionForm.title')}
        onCancel={onComponentValueDefinitionFormHide}
        footer={
          <div>
            <Button onClick={onComponentValueDefinitionFormHide}>
              {t('commons.buttons.close.title')}
            </Button>
            <Button
              onClick={onSaveValueDefinition}
              type="primary"
              disabled={!componentValueDefinition || !valueIsValid(componentValueDefinition)}
            >
              {t('commons.buttons.confirm.title')}
            </Button>
          </div>
        }
      >
        <FileMappingWizardComponentValueDefinitionForm
          appLanguage={appLanguage}
          componentValueDefinition={componentValueDefinition}
          cubeComponents={components}
          onComponentValueDefinitionTypeSet={onComponentValueDefinitionTypeSet}
          onComponentValueDefinitionValueSet={onComponentValueDefinitionValueSet}
          componentCodelistCodesItemsPage={componentCodelistCodesItemsPage}
          componentCodelistCodesItemsCount={componentCodelistCodesItemsCount}
          fetchCodelistCodesItemsPage={fetchCodelistCodesItemsPage}
        />
      </EnhancedModal>

    </Fragment>

  );
}

export default translate()(FileMappingWizardComponentList);
